function PostContinuoOpen() {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Post Contínuo',
    'eventAction': 'Open',
  });
}

function PostContinuoReadingTime(time) {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Post Contínuo',
    'eventAction': 'Reading Time',
    'eventLabel': time
  });

  gtag('event', 'Post Contínuo', {
    'eventAction': 'Reading Time',
    'eventLabel': time
  });
}

function ContagemLeituraPostContinuous(category, subcategory) {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': "Categoria",
    'eventAction': "View - " + category,
    'eventLabel': subcategory
  });

  gtag('event', 'Categoria', {
    'eventAction': "View - " + category,
    'eventLabel': subcategory
  });
}

function ClickNextPost(){
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Progress Bar Post',
    'eventAction': 'Clique - Proximo post',
  });

  gtag('event', 'Progress Bar Post', {
    'eventAction': 'Clique - Proximo post',
  });
}

function ClickShowPosts(){
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Progress Bar Post',
    'eventAction': 'Clique - Mostra posts relacionados',
  });

  gtag('event', 'Progress Bar Post', {
    'eventAction': 'Clique - Mostra posts relacionados',
  });
}

function ClickPostChoose(post){
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Progress Bar Post',
    'eventAction': 'Clique - Post selecionado',
    'eventLabel': post
  });

  gtag('event', 'Progress Bar Post', {
    'eventAction': 'Clique - Post selecionado',
    'eventLabel': post,
  });
}

function RelatedPostPreview(post){
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Post Contínuo',
    'eventAction': 'Preview - Post Relacionado',
    'eventLabel': post
  });

  gtag('event', 'Post Contínuo', {
    'eventAction': 'Preview - Post Relacionado',
    'eventLabel': post
  });
}

function ClickRelatedPostContinueReading(post){
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Post Contínuo',
    'eventAction': 'Clique - Continue Reading',
    'eventLabel': post
  });

  gtag('event', 'Post Contínuo', {
    'eventAction': 'Clique - Continue Reading',
    'eventLabel': post
  });
}
